export const AGREEMENT_TYPE = {
  ADDENDUM: "ADDENDUM",
  CONTRACT: "CONTRACT",
  EXECUTED_CHANGE_ORDER: "EXECUTED_CHANGE_ORDER",
  EXPOSURE: "EXPOSURE",
  POTENTIAL_CHANGE_ORDER: "POTENTIAL_CHANGE_ORDER",
  WORK_AUTHORIZATION: "WORK_AUTHORIZATION",
};
